import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CompanyService, ICompany } from '@services/company';
import { routePathName, routeUrl } from '@app/app.models';
import { environment } from '@env/environment';

@Component({
	selector: 'app-manager-company',
	templateUrl: './company.component.html',
	styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit, OnDestroy {
	public company: ICompany;
	public companyId: string;
	public readonly environment = environment;

	constructor(
		private companyService: CompanyService,
		private router: Router
	) {}

	public ngOnInit(): void {
		this.company = this.companyService.company;
		this.companyId = this.company?.id;

		if (!this.company) {
			setTimeout(() => {
				this.router.navigate(routeUrl(routePathName.apiDocumentation), { replaceUrl: true });
			});
		}
	}

	public ngOnDestroy() {
	}
}
